import { extractJsonFromString } from '../utils/strings'

const ERRORS: Record<string, string> = {
  ['104']: 'invalidWishlist',
  ['105']: 'wishlistNotFound',
  ['106']: 'propertyNotAssigned',
  ['107']: 'propertyAlreadyAssigned',
  ['108']: 'invalidProperty',
  ['109']: 'invalidAccount',
  ['110']: 'wishlistAlreadyShared',
  ['111']: 'wishlistAlNotShared',
  ['112']: 'userIsNotOowner',
  ['113']: 'wishlistLimitReached',
  ['114']: 'wishlistIsFull',
  ['']: 'genericError',
}

export function useWishlistError() {
  const trPrefix = 'errors.wishlist.'
  const { t } = useI18n()

  function getErrorMessage(apiError: ApiError<{ error: string }>) {
    const { error = '' } = apiError.response?._data ?? {}
    const { status = [] } = extractJsonFromString<WishlistError>(error) ?? {}
    const [{ errorCode = '' } = {}] = status
    return t(`${trPrefix}${ERRORS[errorCode]}` as TranslationKey)
  }

  return { getErrorMessage }
}
